import {BaseFlowStep} from "./BaseFlowStep.jsx";
import {Router} from "../../../../stem-core/src/ui/Router.jsx";
import {INLINE_SHOP_URLS} from "../../PanelConstants.js";

export class PurchaseReviewFlowStep extends BaseFlowStep {
    showPanel() {
        Router.changeURL(INLINE_SHOP_URLS.reviewOrder);
    }
}
